import React, { useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Typography, Button, Container, Grid, Box, styled, useMediaQuery, } from '@mui/material';
import { FaFacebookF, FaInstagram, FaYoutube } from 'react-icons/fa';
import BG from '../../../images/BG-True_44.jpg';
import banner1 from '../../../images/355430225_664839485686186_8937260973061722097_n.png';
import banner2 from '../../../images/Ayutthaya Remove People.png'
import map_boattrip45min from '../../../images/map_boattrip45min.png'
import TLS_Auto from '../../../images/logo-auto.svg';
import TLS_Boat from '../../../images/logo-boat.svg';
import { useTranslation } from 'react-i18next';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const LandingpageView = () => {
    const navigate = useNavigate();
    const { t } = useTranslation('booking');
    const { t: popup_promo } = useTranslation('popup_promo');
    const sliderRef = useRef(null);
    const isMobile = useMediaQuery('(max-width:600px)'); // ปรับค่าให้เหมาะสมกับมือถือ
    const isTablet = useMediaQuery('(max-width:900px)');
    const isDesktop = useMediaQuery('(max-width:1200px)');

    useEffect(() => {
        try {
            // any loading logic
        } catch (error) {
            navigate('/404');
        }
    }, []);

    const images = [
        banner1, banner2,
        // Add more images as needed
    ];

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false, // Hide default arrows
    };

    const CyanButton = styled(Button)(({ theme }) => ({
        marginTop: 20,
        background: '#54cfe4',
        color: 'white',
        padding: isMobile ? '4px 16px' : '6px 20px',
        borderRadius: '50px',
        textTransform: 'uppercase',
        fontSize: isMobile ? '14px' : '16px',
        fontWeight: 500,
        letterSpacing: '0.5px',
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        transition: 'all 0.3s ease',
        '&:hover': {
            background: '#3dc3da',
        },
        '& .MuiSvgIcon-root': {
            fontSize: isMobile ? '18px' : '20px',
        },
    }));

    const AddressMapEmbedded = () => {
        return (
            <div className="google-map-code">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3865.236707179288!2d100.54293627633974!3d14.355708686102133!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e27513bc4ee09f%3A0x269ce298a5f8dc40!2sThe%20Wonder%20Blue%20Classic%20Boathouse%20Ayutthaya!5e0!3m2!1sen!2sth!4v1732516592278!5m2!1sen!2sth"
                    style={{ 
                        position: 'relative', 
                        width: '100%', 
                        height: isMobile ? '300px' : '500px', 
                        border: '1px solid #ddd', 
                        borderRadius: '5px', 
                        boxShadow: '1px 1px 5px #eee' 
                    }}
                    allowFullScreen="false"
                    loading="eager"
                    referrerPolicy="no-referrer-when-downgrade" />
            </div>
        );
    };

    return (
        <Box width={'100%'}>
            <Container 
                sx={{ 
                    mt: isMobile ? 1 : 2, 
                    mb: isMobile ? 2 : 4, 
                    ml: 0, 
                    mr: 0, 
                    px: isMobile ? 1 : 2 
                }} 
                maxWidth={false} 
                className="box_display_node"
            >
                <Grid container spacing={isMobile ? 2 : 4} alignItems="center" sx={{ ml: 0, mr: 0 }}>
                    <Grid item xs={12} md={4}>
                        <Box position="relative" sx = {{ width: isMobile ? '96%' : '100%', height: isMobile ? 250 : (isTablet ? 350 : 500) }}>
                            <Slider ref={sliderRef} {...settings}>
                                {images.map((img, index) => (
                                    <Box
                                        key={index}
                                        sx={{
                                            width: '100%',
                                            height: isMobile ? 250 : (isTablet ? 350 : 500),
                                            overflow: 'hidden',
                                            borderRadius: 2,
                                            boxShadow: '2px 2px 10px #cfc8ad',
                                        }}
                                    >
                                        <Box
                                            component="img"
                                            src={img}
                                            alt={`Slide ${index + 1}`}
                                            sx={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'fill',
                                            }}
                                        />
                                    </Box>
                                ))}
                            </Slider>
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={8} mt={isMobile ? 1 : 2}>
                        <Box sx={{ width: isMobile ? '90%' : '96%', mt: isMobile ? 0 : 1, px: isMobile ? 1 :2 }}>
                            <Typography 
                                variant={isMobile ? "h4" : "h3"} 
                                sx={{ 
                                    color: '#54cfe4', 
                                    mb: isMobile ? 1 : 2, 
                                    letterSpacing: isMobile ? '1px' : '2px', 
                                    fontFamily: "'STIX Two Text', serif",
                                    fontSize: isMobile ? '1.5rem' : undefined
                                }}
                            >
                                {t('title1_PRIVATE')}
                            </Typography>
                            <Box sx={{ mt: isMobile ? 1 : 2 }}>
                                <Typography variant="body1" sx={{ color: '#5f5f5f', fontSize: isMobile ? '12px' : '14px' }}>
                                    {t('description1_PRIVATE')}
                                </Typography>
                            </Box>
                            <Box sx={{ mt: isMobile ? 1 : 2, display: 'flex' }}>
                                <Typography variant="body1" sx={{ color: '#5f5f5f', fontSize: isMobile ? '12px' : '14px', paddingLeft: isMobile ? '16px' : '36px' }}>
                                    •
                                </Typography>
                                <Typography variant="body1" sx={{ color: '#5f5f5f', fontSize: isMobile ? '12px' : '14px', paddingLeft: '4px' }}>
                                    {t('subDescription1_PRIVATE')}
                                </Typography>
                            </Box>
                            <Box sx={{ mt: isMobile ? 1 : 2, display: 'flex'  }}>
                                <Typography variant="body1" sx={{ color: '#5f5f5f', fontSize: isMobile ? '12px' : '14px', paddingLeft: isMobile ? '16px' : '36px' }}>
                                    •
                                </Typography>
                                <Typography variant="body1" sx={{ color: '#5f5f5f', fontSize: isMobile ? '12px' : '14px', paddingLeft: '4px' }}>
                                    {t('subDescription2_PRIVATE')}
                                </Typography>
                            </Box>
                            <Box sx={{ mt: isMobile ? 1 : 2 }}>
                                <Typography variant="body1" sx={{ color: '#5f5f5f', fontSize: isMobile ? '12px' : '14px' }}>
                                    {t('description2_PRIVATE')}
                                </Typography>
                            </Box>
                            <Box sx={{ mt: isMobile ? 1 : 2 }}>
                                <Typography variant="body1" sx={{ color: '#5f5f5f', fontSize: isMobile ? '12px' : '14px' }}>
                                    {t('description3_PRIVATE')}
                                </Typography>
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: isMobile ? 2 : 3 }}>
                                <CyanButton 
                                    variant="contained" 
                                    sx={{ 
                                        fontSize: isMobile ? '16px' : '20px', 
                                        width: isMobile ? '200px' : '240px' 
                                    }} 
                                    disableElevation
                                    component="a"
                                    href={'https://trueleasing.co.th/th/hackercraftboat'}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    BOOK NOW
                                </CyanButton>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>

                {/* ----------------------------------------------- */}
                <Grid 
                    container 
                    spacing={isMobile ? 2 : 4} 
                    alignItems="center" 
                    sx={{ 
                        marginTop: isMobile ? '30px' : '50px', 
                        padding: isMobile ? '0px 10px' : '0px 30px'
                    }}
                >
                    <Grid item xs={12} md={6}>
                        <Box position="relative">
                            <Typography 
                                variant={isMobile ? "h6" : "h5"} 
                                sx={{ 
                                    color: '#54cfe4', 
                                    mb: 1, 
                                    mr: 0, 
                                    ml: 0, 
                                    letterSpacing: isMobile ? '1px' : '2px', 
                                    fontFamily: "'STIX Two Text', serif",
                                }}
                            >
                                {t('title_travelling_1')}
                            </Typography>
                            <AddressMapEmbedded />
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Box position="relative" sx={{ mt: isMobile ? 2 : 0 }}>
                            <Typography 
                                variant={isMobile ? "h6" : "h5"} 
                                sx={{ 
                                    color: '#54cfe4', 
                                    mb: 1, 
                                    mr: 0, 
                                    ml: 0, 
                                    letterSpacing: isMobile ? '1px' : '2px', 
                                    fontFamily: "'STIX Two Text', serif",
                                }}
                            >
                                {t('title_travelling_2')}
                            </Typography>

                            <img 
                                src={map_boattrip45min}
                                style={{
                                    position: 'relative',
                                    width: '100%',
                                    height: isMobile ? '300px' : '500px',
                                    border: '1px solid #ddd',
                                    borderRadius: '5px',
                                    boxShadow: '1px 1px 5px #eee',
                                    objectFit: 'fill'
                                }}
                                alt="Boat trip map"
                            />
                        </Box>
                    </Grid>
                </Grid>
                {/* ----------------------------------------------- */}
            </Container>

            <Box component="footer" sx={{
                bgcolor: 'grey.200', 
                p: isMobile ? 2 : 4, 
                marginTop: isMobile ? 5 : 10,
                background: `url(${BG})`,
                backgroundSize: 'cover',
                backgroundPosition: 'top',
                backgroundRepeat: 'no-repeat',
            }}>
                <Container maxWidth={false}>
                    <Grid container spacing={2} justifyContent="center" sx={{ paddingBottom: '10px' }}>
                        <Grid item xs={12} sm={6} textAlign="center">
                            <Box>
                                <img 
                                    src={TLS_Auto} 
                                    alt="Trueleasing Logo" 
                                    style={{ 
                                        height: isMobile ? '50px' : '70px' 
                                    }} 
                                />
                                <img 
                                    src={TLS_Boat} 
                                    alt="Trueleasing Logo" 
                                    style={{ 
                                        height: isMobile ? '50px' : '70px', 
                                        marginLeft: isMobile ? '8px' : '15px' 
                                    }} 
                                />
                            </Box>
                            <Typography 
                                variant={isMobile ? "subtitle1" : "h6"} 
                                color="text.primary" 
                                gutterBottom
                                sx={{ mt: isMobile ? 1 : 2 }}
                            >
                                {t('company_name')}
                            </Typography>
                            <Typography 
                                variant="body2" 
                                color="text.secondary"
                                sx={{ 
                                    fontSize: isMobile ? '11px' : 'inherit', 
                                    mt: isMobile ? 0.5 : 1  
                                }}
                            >
                                {t('address_company')}
                            </Typography>
                            <Typography 
                                variant="body2" 
                                color="text.secondary"
                                sx={{ 
                                    fontSize: isMobile ? '11px' : 'inherit', 
                                    mt: isMobile ? 0.5 : 1
                                }}
                            >
                                E-mail : autorentalbytls@trueleasing.co.th
                            </Typography>
                            <Typography 
                                variant="body2" 
                                color="text.secondary"
                                sx={{ 
                                    fontSize: isMobile ? '11px' : 'inherit', 
                                    mt: isMobile ? 0.5 : 1
                                }}
                            >
                                Tel : 02-859-7878
                            </Typography>
                            <Box 
                                sx={{ 
                                    display: 'flex', 
                                    flexDirection: isMobile ? 'column' : 'row',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: isMobile ? 1 : 0,
                                    mt: 2
                                }}
                            >
                                <Button
                                    component={Link}
                                    to={'https://www.facebook.com/Autorentalbytrueleasing/'}
                                    color="info" 
                                    startIcon={<FaFacebookF />}
                                    variant="outlined" 
                                    size={isMobile ? "small" : "medium"} 
                                    sx={{ 
                                        marginRight: isMobile ? 0 : '10px',
                                        fontSize: isMobile ? '10px' : 'inherit',
                                        width: isMobile ? '200px' : 'auto'
                                    }}
                                >
                                    True Leasing
                                </Button>
                                <Button
                                    component={Link}
                                    to={'https://www.instagram.com/trueleasing/'}
                                    color="info" 
                                    startIcon={<FaInstagram />}
                                    variant="outlined"
                                    size={isMobile ? "small" : "medium"}
                                    sx={{ 
                                        marginRight: isMobile ? 0 : '10px',
                                        marginTop: isMobile ? 1 : 0,
                                        fontSize: isMobile ? '10px' : 'inherit',
                                        width: isMobile ? '200px' : 'auto'
                                    }}
                                >
                                    Trueleasing.co.th
                                </Button>
                                <Button
                                    component={Link}
                                    to={'https://www.youtube.com/channel/UCoYFVV9GwYsnHIjeWG3Ipiw'}
                                    color="info"
                                    startIcon={<FaYoutube />}
                                    variant="outlined"
                                    size={isMobile ? "small" : "medium"}
                                    sx={{ 
                                        marginTop: isMobile ? 1 : 0,
                                        fontSize: isMobile ? '10px' : 'inherit',
                                        width: isMobile ? '200px' : 'auto'
                                    }}
                                >
                                    True Leasing
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
        </Box>
    );
};

export default LandingpageView;